let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("6jw5Q")).then(() => parcelRequire('lTRsf'));